module.exports = __webpack_public_path__ + "9e3ab8a37de5fb4f9ef9884f358e731c.svg";